import React, {Fragment} from 'react';
import {Button, Col, FormControl, Row} from 'react-bootstrap';
import {SB_ENTER_KEY_CODE} from "../../../Constants";
import {KeyboardUtils} from "../../../Utils";

export const ForgotPasswordForm = (props) => {
    const {
        Submit = () => {},
        UpdatePassword,
        UpdatePassword2,
        Password,
        Password2
    } = props;
    
    const handleKeyPress = (event) => KeyboardUtils.handleKeyPress(SB_ENTER_KEY_CODE, event, Submit);
    
    return (
        <Fragment>
            <Row className="top10">
                <Col md={4}>
                    <span>New Password</span>
                </Col>
                <Col md={8}>
                    <FormControl
                        autocomplete="new-password"
                        autoFocus
                        type="password"
                        name="password1"
                        value={Password}
                        onChange={(e) => UpdatePassword(e.target.value)}
                        onKeyDown={handleKeyPress}
                    />
                </Col>
            </Row>
            <Row className="top10">
                <Col md={4}>
                    <span>Confirm New Password</span>
                </Col>
                <Col md={8}>
                    <FormControl
                        autocomplete="new-password"
                        type="password"
                        name="password2"
                        value={Password2}
                        onChange={(e) => UpdatePassword2(e.target.value)}
                        onKeyDown={handleKeyPress}
                    />
                </Col>
            </Row>
            <Row className="top10">
                <Col md={4}/>
                <Col md={8}>
                    <Button onClick={Submit} variant="primary">Update Password</Button>
                </Col>
            </Row>
            <Row className="top10">
                <Col md={4}/>
                <Col md={8}><br/></Col>
            </Row>
        </Fragment>
    );
};


